import { useEffect, useRef, useState } from "react";

export const useInView = (options = {}) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    useEffect(() => {
        if (!ref.current) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    obs.disconnect();
                }
            },
            { threshold: 0.2, ...options }
        );
        obs.observe(ref.current);
        return () => obs.disconnect();
    }, []);
    return [ref, inView];
};
